import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, switchMap, withLatestFrom } from "rxjs/operators";

import { ConsumerAdminService } from "../../../services/api/consumer-admin.service";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { ConsumerRolesState } from "../../models/consumer-admin/consumer-roles.state";
import { FailState } from "../../models/fail-state";
import { AppState } from "../../reducers";
import { ConsumerAdminSelectors } from "../../selectors/consumer-admin.selectors";

@Injectable()
export class ConsumerRolesGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.consumerRoles.get),
			withLatestFrom(this.store.select(ConsumerAdminSelectors.consumerRoles)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(ConsumerAdminActions.consumerRoles.getSuccess(state))
					: of(ConsumerAdminActions.consumerRoles.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.consumerRoles.getApi),
			switchMap(() =>
				this.consumerAdminService.getConsumerRoles().pipe(
					switchMap((roles) =>
						of(ConsumerAdminActions.consumerRoles.getSuccess({ roles }))
					),
					catchError((error) =>
						of(ConsumerAdminActions.consumerRoles.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private actions: Actions,
		private consumerAdminService: ConsumerAdminService
	) {}

	private canUseStoreValue(state: ConsumerRolesState): boolean {
		return !_.has(state, "error") && !state.loading && !_.has(state, "roles");
	}
}
